import { useProgressCalculation } from '../hooks/useProgressCalculation';

export const LoadingBar = ({
  percentCompleted,
}: {
  percentCompleted: number;
}) => {
  return (
    <div className="w-full bg-indigo-100 rounded-full h-1 max-w-full nxl:max-w-160 nmd:max-w-115">
      <div
        className="bg-indigo-700 h-1 rounded-full transition-all duration-800 ease-in-out"
        style={{ width: `${percentCompleted}%` }}
      />
    </div>
  );
};

export const ProgressBar = () => {
  const progress = useProgressCalculation();

  return (
    <div className="w-full flex flex-col items-center justify-center gap-2">
      <div className="flex items-center justify-center w-full sm:w-56 sm:h-4.5">
        <LoadingBar percentCompleted={progress} />
      </div>
    </div>
  );
};
